import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const mintmarkPurple = svgToTinyDataUri(
  `<svg preserveAspectRatio="none" width="100%" height="100%" overflow="visible" style="display: block;" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="mintmark">
<mask id="mask0_0_43" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
<rect id="Bounding box" width="32" height="32" fill="var(--fill-0, #D9D9D9)"/>
</mask>
<g mask="url(#mask0_0_43)">
<path id="mintmark_2" d="M17.3333 28V25.3333H23.4667L17.3333 19.2V15.4667L25.3333 23.4667V17.3333H28V28H17.3333ZM8 22.6667V21.3333H4V18.6667H12V14.6667H6.66667C5.93333 14.6667 5.30556 14.4056 4.78333 13.8833C4.26111 13.3611 4 12.7333 4 12V8C4 7.26667 4.26111 6.63889 4.78333 6.11667C5.30556 5.59444 5.93333 5.33333 6.66667 5.33333H8V4H10.6667V5.33333H14.6667V8H6.66667V12H12C12.7333 12 13.3611 12.2611 13.8833 12.7833C14.4056 13.3056 14.6667 13.9333 14.6667 14.6667V18.6667C14.6667 19.4 14.4056 20.0278 13.8833 20.55C13.3611 21.0722 12.7333 21.3333 12 21.3333H10.6667V22.6667H8Z" fill="var(--fill-0, #501283)"/>
</g>
</g>
</svg>`
);
